var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
const MONTH_LABEL_W = 50; // px — sticky left column
const ROW_H = 36; // px per month row
const MIN_DAY_W = 24; // minimum day-column width before scroll kicks in
const TOTAL_COLS = 37; // max grid columns (6 offset + 31 days)
/** Diagonal stripe SVG for non-work-day background */
export const NON_WORK_BG = `url("data:image/svg+xml,%3Csvg width='8' height='8' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M-1,1 l4,-4 M0,8 l8,-8 M7,9 l4,-4' stroke='%23c8c6c4' stroke-width='1'/%3E%3C/svg%3E")`;
export const styles = {
    wrapper: {
        overflowX: 'auto',
        overflowY: 'auto',
        maxHeight: 'calc(100vh - 160px)',
        width: '100%',
        position: 'relative',
    },
    table: {
        borderCollapse: 'collapse',
        tableLayout: 'fixed',
        width: '100%',
        minWidth: `${MONTH_LABEL_W + TOTAL_COLS * MIN_DAY_W}px`,
        fontSize: '12px',
        fontFamily: '"Segoe UI","Segoe UI Web (West European)",-apple-system,BlinkMacSystemFont,Roboto,"Helvetica Neue",sans-serif',
        color: '#323130',
    },
    /* --- Header row --- */
    dowHeaderCell: {
        textAlign: 'center',
        padding: '4px 0',
        fontWeight: 600,
        fontSize: '11px',
        color: '#605e5c',
        borderBottom: 'none',
        paddingBottom: '6px',
        position: 'sticky',
        top: 0,
        backgroundColor: '#ffffff',
        zIndex: 2,
    },
    /** Non-work-day DOW header: subtle shading to visually align with body cells */
    dowHeaderCellNonWork: {
        backgroundColor: '#deecf9',
        color: '#605e5c',
    },
    monthLabelHeader: {
        width: MONTH_LABEL_W,
        minWidth: MONTH_LABEL_W,
        maxWidth: MONTH_LABEL_W,
        position: 'sticky',
        left: 0,
        top: 0,
        backgroundColor: '#ffffff',
        zIndex: 3,
        borderBottom: 'none',
        paddingBottom: '6px',
    },
    /* --- Month label (left column) --- */
    monthLabel: {
        width: MONTH_LABEL_W,
        minWidth: MONTH_LABEL_W,
        maxWidth: MONTH_LABEL_W,
        fontWeight: 700,
        fontSize: '12px',
        color: '#323130',
        textAlign: 'left',
        padding: '0 6px',
        verticalAlign: 'middle',
        position: 'sticky',
        left: 0,
        backgroundColor: '#ffffff',
        zIndex: 1,
        borderRight: '1px solid #ffffff',
        height: ROW_H,
    },
    /* --- Day cell — no fixed width; table distributes evenly --- */
    dayCell: {
        height: ROW_H,
        textAlign: 'center',
        verticalAlign: 'middle',
        cursor: 'pointer',
        padding: 0,
        borderLeft: '1px solid #ffffff',
        borderRight: '1px solid #ffffff',
        borderTop: '2px solid #ffffff',
        borderBottom: '2px solid #ffffff',
        position: 'relative',
        fontSize: '12px',
        lineHeight: `${ROW_H}px`,
        backgroundColor: '#f5f5f6',
    },
    dayCellNonWork: {
        backgroundColor: '#deecf9',
    },
    dayCellToday: {
        outline: '2px solid #0078d4',
        outlineOffset: '-2px',
        fontWeight: 700,
        zIndex: 1,
    },
    dayCellEmpty: {
        backgroundColor: '#ffffff',
        cursor: 'default',
    },
    dayCellHasEvent: {
        fontWeight: 600,
    },
    /* --- Event bars container (stacked at bottom of cell) --- */
    eventBarContainer: {
        position: 'absolute',
        bottom: 1,
        left: 1,
        right: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
    },
    eventBlock: {
        height: 3,
        borderRadius: 1,
    },
};
export default styles;
//# sourceMappingURL=YearView.styles.js.map